import React from "react";

const Sidebar = () => {
  return (
    <div className="w-36 border-l h-screen bg-molstar-border text-molstar-brown font-light text-xs text-center p-4">
      Custom Controls
    </div>
  );
};

Sidebar.propTypes = {
  
};

export default Sidebar;